module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_null@3x.77730c8d.png";